import { setCookieFromQuery } from '@/util/set-cookie'

export default function({ query }) {
  setCookieFromQuery(query)
}
